export const OpeningHoursTableHeaders = [
  "opening-hours-name",
  "language",
  "modify",
];
